/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptInputBody,
  AcceptOutputBody,
  ChangeRoleInputBody,
  ErrorModel,
  InvitationPreviewOutputBody,
  InviteInputBody,
  InviteOutputBody,
  MembersOutputBody,
  UsersChangeRoleHeaders
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type usersInvitationPreviewResponse200 = {
  data: InvitationPreviewOutputBody
  status: 200
}

export type usersInvitationPreviewResponse404 = {
  data: ErrorModel
  status: 404
}

export type usersInvitationPreviewResponse422 = {
  data: ErrorModel
  status: 422
}

export type usersInvitationPreviewResponse500 = {
  data: ErrorModel
  status: 500
}

export type usersInvitationPreviewResponseSuccess = (usersInvitationPreviewResponse200) & {
  headers: Headers;
};
export type usersInvitationPreviewResponseError = (usersInvitationPreviewResponse404 | usersInvitationPreviewResponse422 | usersInvitationPreviewResponse500) & {
  headers: Headers;
};

export type usersInvitationPreviewResponse = (usersInvitationPreviewResponseSuccess | usersInvitationPreviewResponseError)

export const getUsersInvitationPreviewUrl = (token: string,) => {




  return `/invitations/token/${token}`
}

/**
 * Открыто без входа: человек ещё не вошёл, он как раз по этой ссылке и собирается завестись. Отдаёт только то, что он и так узнает, приняв приглашение.
 * @summary Посмотреть приглашение
 */
export const usersInvitationPreview = async (token: string, options?: Parameters<typeof facetaFetch>[1]): Promise<usersInvitationPreviewResponse> => {

  return facetaFetch<usersInvitationPreviewResponse>(getUsersInvitationPreviewUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersInvitationPreviewQueryKey = (token: string,) => {
    return [
    `/invitations/token/${token}`
    ] as const;
    }


export const getUsersInvitationPreviewQueryOptions = <TData = Awaited<ReturnType<typeof usersInvitationPreview>>, TError = ErrorModel>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInvitationPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersInvitationPreviewQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersInvitationPreview>>> = ({ signal }) => usersInvitationPreview(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersInvitationPreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersInvitationPreviewQueryResult = NonNullable<Awaited<ReturnType<typeof usersInvitationPreview>>>
export type UsersInvitationPreviewQueryError = ErrorModel


export function useUsersInvitationPreview<TData = Awaited<ReturnType<typeof usersInvitationPreview>>, TError = ErrorModel>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInvitationPreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersInvitationPreview>>,
          TError,
          Awaited<ReturnType<typeof usersInvitationPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersInvitationPreview<TData = Awaited<ReturnType<typeof usersInvitationPreview>>, TError = ErrorModel>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInvitationPreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersInvitationPreview>>,
          TError,
          Awaited<ReturnType<typeof usersInvitationPreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersInvitationPreview<TData = Awaited<ReturnType<typeof usersInvitationPreview>>, TError = ErrorModel>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInvitationPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Посмотреть приглашение
 */

export function useUsersInvitationPreview<TData = Awaited<ReturnType<typeof usersInvitationPreview>>, TError = ErrorModel>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInvitationPreview>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersInvitationPreviewQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type usersAcceptInvitationResponse200 = {
  data: AcceptOutputBody
  status: 200
}

export type usersAcceptInvitationResponse404 = {
  data: ErrorModel
  status: 404
}

export type usersAcceptInvitationResponse409 = {
  data: ErrorModel
  status: 409
}

export type usersAcceptInvitationResponse422 = {
  data: ErrorModel
  status: 422
}

export type usersAcceptInvitationResponse500 = {
  data: ErrorModel
  status: 500
}

export type usersAcceptInvitationResponseSuccess = (usersAcceptInvitationResponse200) & {
  headers: Headers;
};
export type usersAcceptInvitationResponseError = (usersAcceptInvitationResponse404 | usersAcceptInvitationResponse409 | usersAcceptInvitationResponse422 | usersAcceptInvitationResponse500) & {
  headers: Headers;
};

export type usersAcceptInvitationResponse = (usersAcceptInvitationResponseSuccess | usersAcceptInvitationResponseError)

export const getUsersAcceptInvitationUrl = (token: string,) => {




  return `/invitations/token/${token}/accept`
}

/**
 * Заводит учётную запись или дополняет существующую и выдаёт роль. Пароль ставится только тому, у кого его ещё нет: иначе приглашением можно было бы перехватить чужую учётную запись.
 * @summary Принять приглашение
 */
export const usersAcceptInvitation = async (token: string,
    acceptInputBody: NonReadonly<AcceptInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<usersAcceptInvitationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<usersAcceptInvitationResponse>(getUsersAcceptInvitationUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(acceptInputBody)
  }
);}





export const getUsersAcceptInvitationQueryKey = (token: string,
    acceptInputBody?: NonReadonly<AcceptInputBody>,) => {
    return [
    'POST', `/invitations/token/${token}/accept`, acceptInputBody
    ] as const;
    }


export const getUsersAcceptInvitationQueryOptions = <TData = Awaited<ReturnType<typeof usersAcceptInvitation>>, TError = ErrorModel>(token: string,
    acceptInputBody: NonReadonly<AcceptInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersAcceptInvitation>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersAcceptInvitationQueryKey(token,acceptInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersAcceptInvitation>>> = ({ signal }) => usersAcceptInvitation(token,acceptInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersAcceptInvitation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersAcceptInvitationQueryResult = NonNullable<Awaited<ReturnType<typeof usersAcceptInvitation>>>
export type UsersAcceptInvitationQueryError = ErrorModel


export function useUsersAcceptInvitation<TData = Awaited<ReturnType<typeof usersAcceptInvitation>>, TError = ErrorModel>(
 token: string,
    acceptInputBody: NonReadonly<AcceptInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersAcceptInvitation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersAcceptInvitation>>,
          TError,
          Awaited<ReturnType<typeof usersAcceptInvitation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersAcceptInvitation<TData = Awaited<ReturnType<typeof usersAcceptInvitation>>, TError = ErrorModel>(
 token: string,
    acceptInputBody: NonReadonly<AcceptInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersAcceptInvitation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersAcceptInvitation>>,
          TError,
          Awaited<ReturnType<typeof usersAcceptInvitation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersAcceptInvitation<TData = Awaited<ReturnType<typeof usersAcceptInvitation>>, TError = ErrorModel>(
 token: string,
    acceptInputBody: NonReadonly<AcceptInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersAcceptInvitation>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Принять приглашение
 */

export function useUsersAcceptInvitation<TData = Awaited<ReturnType<typeof usersAcceptInvitation>>, TError = ErrorModel>(
 token: string,
    acceptInputBody: NonReadonly<AcceptInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersAcceptInvitation>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersAcceptInvitationQueryOptions(token,acceptInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type usersRevokeInvitationResponse204 = {
  data: void
  status: 204
}

export type usersRevokeInvitationResponse401 = {
  data: ErrorModel
  status: 401
}

export type usersRevokeInvitationResponse403 = {
  data: ErrorModel
  status: 403
}

export type usersRevokeInvitationResponse404 = {
  data: ErrorModel
  status: 404
}

export type usersRevokeInvitationResponse422 = {
  data: ErrorModel
  status: 422
}

export type usersRevokeInvitationResponse500 = {
  data: ErrorModel
  status: 500
}

export type usersRevokeInvitationResponseSuccess = (usersRevokeInvitationResponse204) & {
  headers: Headers;
};
export type usersRevokeInvitationResponseError = (usersRevokeInvitationResponse401 | usersRevokeInvitationResponse403 | usersRevokeInvitationResponse404 | usersRevokeInvitationResponse422 | usersRevokeInvitationResponse500) & {
  headers: Headers;
};

export type usersRevokeInvitationResponse = (usersRevokeInvitationResponseSuccess | usersRevokeInvitationResponseError)

export const getUsersRevokeInvitationUrl = (invitationId: string,) => {




  return `/invitations/${invitationId}`
}

/**
 * @summary Отозвать приглашение
 */
export const usersRevokeInvitation = async (invitationId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<usersRevokeInvitationResponse> => {

  return facetaFetch<usersRevokeInvitationResponse>(getUsersRevokeInvitationUrl(invitationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUsersRevokeInvitationQueryKey = (invitationId: string,) => {
    return [
    'DELETE', `/invitations/${invitationId}`
    ] as const;
    }


export const getUsersRevokeInvitationQueryOptions = <TData = Awaited<ReturnType<typeof usersRevokeInvitation>>, TError = ErrorModel>(invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRevokeInvitation>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRevokeInvitationQueryKey(invitationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRevokeInvitation>>> = ({ signal }) => usersRevokeInvitation(invitationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: invitationId !== null && invitationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRevokeInvitation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRevokeInvitationQueryResult = NonNullable<Awaited<ReturnType<typeof usersRevokeInvitation>>>
export type UsersRevokeInvitationQueryError = ErrorModel


export function useUsersRevokeInvitation<TData = Awaited<ReturnType<typeof usersRevokeInvitation>>, TError = ErrorModel>(
 invitationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRevokeInvitation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRevokeInvitation>>,
          TError,
          Awaited<ReturnType<typeof usersRevokeInvitation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRevokeInvitation<TData = Awaited<ReturnType<typeof usersRevokeInvitation>>, TError = ErrorModel>(
 invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRevokeInvitation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRevokeInvitation>>,
          TError,
          Awaited<ReturnType<typeof usersRevokeInvitation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRevokeInvitation<TData = Awaited<ReturnType<typeof usersRevokeInvitation>>, TError = ErrorModel>(
 invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRevokeInvitation>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Отозвать приглашение
 */

export function useUsersRevokeInvitation<TData = Awaited<ReturnType<typeof usersRevokeInvitation>>, TError = ErrorModel>(
 invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRevokeInvitation>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRevokeInvitationQueryOptions(invitationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type usersRemoveMemberResponse204 = {
  data: void
  status: 204
}

export type usersRemoveMemberResponse401 = {
  data: ErrorModel
  status: 401
}

export type usersRemoveMemberResponse403 = {
  data: ErrorModel
  status: 403
}

export type usersRemoveMemberResponse404 = {
  data: ErrorModel
  status: 404
}

export type usersRemoveMemberResponse409 = {
  data: ErrorModel
  status: 409
}

export type usersRemoveMemberResponse422 = {
  data: ErrorModel
  status: 422
}

export type usersRemoveMemberResponse500 = {
  data: ErrorModel
  status: 500
}

export type usersRemoveMemberResponseSuccess = (usersRemoveMemberResponse204) & {
  headers: Headers;
};
export type usersRemoveMemberResponseError = (usersRemoveMemberResponse401 | usersRemoveMemberResponse403 | usersRemoveMemberResponse404 | usersRemoveMemberResponse409 | usersRemoveMemberResponse422 | usersRemoveMemberResponse500) & {
  headers: Headers;
};

export type usersRemoveMemberResponse = (usersRemoveMemberResponseSuccess | usersRemoveMemberResponseError)

export const getUsersRemoveMemberUrl = (membershipId: string,) => {




  return `/memberships/${membershipId}`
}

/**
 * Последнего администратора тенанта снять нельзя: тенант без него становится неуправляемым, и вернуть его к жизни сможет только владелец платформы.
 * @summary Снять роль
 */
export const usersRemoveMember = async (membershipId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<usersRemoveMemberResponse> => {

  return facetaFetch<usersRemoveMemberResponse>(getUsersRemoveMemberUrl(membershipId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getUsersRemoveMemberQueryKey = (membershipId: string,) => {
    return [
    'DELETE', `/memberships/${membershipId}`
    ] as const;
    }


export const getUsersRemoveMemberQueryOptions = <TData = Awaited<ReturnType<typeof usersRemoveMember>>, TError = ErrorModel>(membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRemoveMember>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRemoveMemberQueryKey(membershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRemoveMember>>> = ({ signal }) => usersRemoveMember(membershipId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: membershipId !== null && membershipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRemoveMember>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRemoveMemberQueryResult = NonNullable<Awaited<ReturnType<typeof usersRemoveMember>>>
export type UsersRemoveMemberQueryError = ErrorModel


export function useUsersRemoveMember<TData = Awaited<ReturnType<typeof usersRemoveMember>>, TError = ErrorModel>(
 membershipId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRemoveMember>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRemoveMember>>,
          TError,
          Awaited<ReturnType<typeof usersRemoveMember>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRemoveMember<TData = Awaited<ReturnType<typeof usersRemoveMember>>, TError = ErrorModel>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRemoveMember>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRemoveMember>>,
          TError,
          Awaited<ReturnType<typeof usersRemoveMember>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRemoveMember<TData = Awaited<ReturnType<typeof usersRemoveMember>>, TError = ErrorModel>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRemoveMember>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Снять роль
 */

export function useUsersRemoveMember<TData = Awaited<ReturnType<typeof usersRemoveMember>>, TError = ErrorModel>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRemoveMember>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRemoveMemberQueryOptions(membershipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type usersChangeRoleResponse204 = {
  data: void
  status: 204
}

export type usersChangeRoleResponse401 = {
  data: ErrorModel
  status: 401
}

export type usersChangeRoleResponse403 = {
  data: ErrorModel
  status: 403
}

export type usersChangeRoleResponse404 = {
  data: ErrorModel
  status: 404
}

export type usersChangeRoleResponse409 = {
  data: ErrorModel
  status: 409
}

export type usersChangeRoleResponse422 = {
  data: ErrorModel
  status: 422
}

export type usersChangeRoleResponse500 = {
  data: ErrorModel
  status: 500
}

export type usersChangeRoleResponseSuccess = (usersChangeRoleResponse204) & {
  headers: Headers;
};
export type usersChangeRoleResponseError = (usersChangeRoleResponse401 | usersChangeRoleResponse403 | usersChangeRoleResponse404 | usersChangeRoleResponse409 | usersChangeRoleResponse422 | usersChangeRoleResponse500) & {
  headers: Headers;
};

export type usersChangeRoleResponse = (usersChangeRoleResponseSuccess | usersChangeRoleResponseError)

export const getUsersChangeRoleUrl = (membershipId: string,) => {




  return `/memberships/${membershipId}/role`
}

/**
 * Меняет роль внутри той же области. Перевод человека с уровня сайта на уровень тенанта — это снятие одной роли и выдача другой, и выглядеть в журнале он должен так же.
 * @summary Сменить роль
 */
export const usersChangeRole = async (membershipId: string,
    changeRoleInputBody: NonReadonly<ChangeRoleInputBody>,
    headers: UsersChangeRoleHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<usersChangeRoleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<usersChangeRoleResponse>(getUsersChangeRoleUrl(membershipId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(changeRoleInputBody)
  }
);}





export const getUsersChangeRoleQueryKey = (membershipId: string,
    changeRoleInputBody?: NonReadonly<ChangeRoleInputBody>,) => {
    return [
    'PUT', `/memberships/${membershipId}/role`, changeRoleInputBody
    ] as const;
    }


export const getUsersChangeRoleQueryOptions = <TData = Awaited<ReturnType<typeof usersChangeRole>>, TError = ErrorModel>(membershipId: string,
    changeRoleInputBody: NonReadonly<ChangeRoleInputBody>,
    headers: UsersChangeRoleHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersChangeRole>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersChangeRoleQueryKey(membershipId,changeRoleInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersChangeRole>>> = ({ signal }) => usersChangeRole(membershipId,changeRoleInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: membershipId !== null && membershipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersChangeRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersChangeRoleQueryResult = NonNullable<Awaited<ReturnType<typeof usersChangeRole>>>
export type UsersChangeRoleQueryError = ErrorModel


export function useUsersChangeRole<TData = Awaited<ReturnType<typeof usersChangeRole>>, TError = ErrorModel>(
 membershipId: string,
    changeRoleInputBody: NonReadonly<ChangeRoleInputBody>,
    headers: UsersChangeRoleHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersChangeRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersChangeRole>>,
          TError,
          Awaited<ReturnType<typeof usersChangeRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersChangeRole<TData = Awaited<ReturnType<typeof usersChangeRole>>, TError = ErrorModel>(
 membershipId: string,
    changeRoleInputBody: NonReadonly<ChangeRoleInputBody>,
    headers: UsersChangeRoleHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersChangeRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersChangeRole>>,
          TError,
          Awaited<ReturnType<typeof usersChangeRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersChangeRole<TData = Awaited<ReturnType<typeof usersChangeRole>>, TError = ErrorModel>(
 membershipId: string,
    changeRoleInputBody: NonReadonly<ChangeRoleInputBody>,
    headers: UsersChangeRoleHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersChangeRole>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Сменить роль
 */

export function useUsersChangeRole<TData = Awaited<ReturnType<typeof usersChangeRole>>, TError = ErrorModel>(
 membershipId: string,
    changeRoleInputBody: NonReadonly<ChangeRoleInputBody>,
    headers: UsersChangeRoleHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersChangeRole>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersChangeRoleQueryOptions(membershipId,changeRoleInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type usersListSiteMembersResponse200 = {
  data: MembersOutputBody
  status: 200
}

export type usersListSiteMembersResponse401 = {
  data: ErrorModel
  status: 401
}

export type usersListSiteMembersResponse403 = {
  data: ErrorModel
  status: 403
}

export type usersListSiteMembersResponse404 = {
  data: ErrorModel
  status: 404
}

export type usersListSiteMembersResponse422 = {
  data: ErrorModel
  status: 422
}

export type usersListSiteMembersResponse500 = {
  data: ErrorModel
  status: 500
}

export type usersListSiteMembersResponseSuccess = (usersListSiteMembersResponse200) & {
  headers: Headers;
};
export type usersListSiteMembersResponseError = (usersListSiteMembersResponse401 | usersListSiteMembersResponse403 | usersListSiteMembersResponse404 | usersListSiteMembersResponse422 | usersListSiteMembersResponse500) & {
  headers: Headers;
};

export type usersListSiteMembersResponse = (usersListSiteMembersResponseSuccess | usersListSiteMembersResponseError)

export const getUsersListSiteMembersUrl = (siteId: string,) => {




  return `/sites/${siteId}/members`
}

/**
 * Все, у кого есть доступ к сайту: роли на весь его тенант и на сам сайт, плюс приглашения, которые такой доступ дадут. Доступно тем, кто управляет людьми сайта.
 * @summary Люди сайта
 */
export const usersListSiteMembers = async (siteId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<usersListSiteMembersResponse> => {

  return facetaFetch<usersListSiteMembersResponse>(getUsersListSiteMembersUrl(siteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersListSiteMembersQueryKey = (siteId: string,) => {
    return [
    `/sites/${siteId}/members`
    ] as const;
    }


export const getUsersListSiteMembersQueryOptions = <TData = Awaited<ReturnType<typeof usersListSiteMembers>>, TError = ErrorModel>(siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListSiteMembers>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersListSiteMembersQueryKey(siteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersListSiteMembers>>> = ({ signal }) => usersListSiteMembers(siteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: siteId !== null && siteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersListSiteMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersListSiteMembersQueryResult = NonNullable<Awaited<ReturnType<typeof usersListSiteMembers>>>
export type UsersListSiteMembersQueryError = ErrorModel


export function useUsersListSiteMembers<TData = Awaited<ReturnType<typeof usersListSiteMembers>>, TError = ErrorModel>(
 siteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListSiteMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersListSiteMembers>>,
          TError,
          Awaited<ReturnType<typeof usersListSiteMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersListSiteMembers<TData = Awaited<ReturnType<typeof usersListSiteMembers>>, TError = ErrorModel>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListSiteMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersListSiteMembers>>,
          TError,
          Awaited<ReturnType<typeof usersListSiteMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersListSiteMembers<TData = Awaited<ReturnType<typeof usersListSiteMembers>>, TError = ErrorModel>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListSiteMembers>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Люди сайта
 */

export function useUsersListSiteMembers<TData = Awaited<ReturnType<typeof usersListSiteMembers>>, TError = ErrorModel>(
 siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListSiteMembers>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersListSiteMembersQueryOptions(siteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type usersInviteResponse201 = {
  data: InviteOutputBody
  status: 201
}

export type usersInviteResponse401 = {
  data: ErrorModel
  status: 401
}

export type usersInviteResponse403 = {
  data: ErrorModel
  status: 403
}

export type usersInviteResponse404 = {
  data: ErrorModel
  status: 404
}

export type usersInviteResponse409 = {
  data: ErrorModel
  status: 409
}

export type usersInviteResponse422 = {
  data: ErrorModel
  status: 422
}

export type usersInviteResponse500 = {
  data: ErrorModel
  status: 500
}

export type usersInviteResponseSuccess = (usersInviteResponse201) & {
  headers: Headers;
};
export type usersInviteResponseError = (usersInviteResponse401 | usersInviteResponse403 | usersInviteResponse404 | usersInviteResponse409 | usersInviteResponse422 | usersInviteResponse500) & {
  headers: Headers;
};

export type usersInviteResponse = (usersInviteResponseSuccess | usersInviteResponseError)

export const getUsersInviteUrl = (tenantId: string,) => {




  return `/tenants/${tenantId}/invitations`
}

/**
 * Выписывает ссылку-приглашение и отдаёт её один раз: в базе лежит только отпечаток. Повторное приглашение того же адреса в ту же область отзывает прежнюю ссылку — иначе на руках оказывается несколько работающих входов.
 * @summary Пригласить человека
 */
export const usersInvite = async (tenantId: string,
    inviteInputBody: NonReadonly<InviteInputBody>, options?: Parameters<typeof facetaFetch>[1]): Promise<usersInviteResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<usersInviteResponse>(getUsersInviteUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(inviteInputBody)
  }
);}





export const getUsersInviteQueryKey = (tenantId: string,
    inviteInputBody?: NonReadonly<InviteInputBody>,) => {
    return [
    'POST', `/tenants/${tenantId}/invitations`, inviteInputBody
    ] as const;
    }


export const getUsersInviteQueryOptions = <TData = Awaited<ReturnType<typeof usersInvite>>, TError = ErrorModel>(tenantId: string,
    inviteInputBody: NonReadonly<InviteInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInvite>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersInviteQueryKey(tenantId,inviteInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersInvite>>> = ({ signal }) => usersInvite(tenantId,inviteInputBody, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersInvite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersInviteQueryResult = NonNullable<Awaited<ReturnType<typeof usersInvite>>>
export type UsersInviteQueryError = ErrorModel


export function useUsersInvite<TData = Awaited<ReturnType<typeof usersInvite>>, TError = ErrorModel>(
 tenantId: string,
    inviteInputBody: NonReadonly<InviteInputBody>, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInvite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersInvite>>,
          TError,
          Awaited<ReturnType<typeof usersInvite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersInvite<TData = Awaited<ReturnType<typeof usersInvite>>, TError = ErrorModel>(
 tenantId: string,
    inviteInputBody: NonReadonly<InviteInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInvite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersInvite>>,
          TError,
          Awaited<ReturnType<typeof usersInvite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersInvite<TData = Awaited<ReturnType<typeof usersInvite>>, TError = ErrorModel>(
 tenantId: string,
    inviteInputBody: NonReadonly<InviteInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInvite>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Пригласить человека
 */

export function useUsersInvite<TData = Awaited<ReturnType<typeof usersInvite>>, TError = ErrorModel>(
 tenantId: string,
    inviteInputBody: NonReadonly<InviteInputBody>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersInvite>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersInviteQueryOptions(tenantId,inviteInputBody,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type usersListMembersResponse200 = {
  data: MembersOutputBody
  status: 200
}

export type usersListMembersResponse401 = {
  data: ErrorModel
  status: 401
}

export type usersListMembersResponse403 = {
  data: ErrorModel
  status: 403
}

export type usersListMembersResponse404 = {
  data: ErrorModel
  status: 404
}

export type usersListMembersResponse422 = {
  data: ErrorModel
  status: 422
}

export type usersListMembersResponse500 = {
  data: ErrorModel
  status: 500
}

export type usersListMembersResponseSuccess = (usersListMembersResponse200) & {
  headers: Headers;
};
export type usersListMembersResponseError = (usersListMembersResponse401 | usersListMembersResponse403 | usersListMembersResponse404 | usersListMembersResponse422 | usersListMembersResponse500) & {
  headers: Headers;
};

export type usersListMembersResponse = (usersListMembersResponseSuccess | usersListMembersResponseError)

export const getUsersListMembersUrl = (tenantId: string,) => {




  return `/tenants/${tenantId}/members`
}

/**
 * Роли и незакрытые приглашения одним ответом: на экране это один список.
 * @summary Люди тенанта
 */
export const usersListMembers = async (tenantId: string, options?: Parameters<typeof facetaFetch>[1]): Promise<usersListMembersResponse> => {

  return facetaFetch<usersListMembersResponse>(getUsersListMembersUrl(tenantId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersListMembersQueryKey = (tenantId: string,) => {
    return [
    `/tenants/${tenantId}/members`
    ] as const;
    }


export const getUsersListMembersQueryOptions = <TData = Awaited<ReturnType<typeof usersListMembers>>, TError = ErrorModel>(tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListMembers>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersListMembersQueryKey(tenantId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersListMembers>>> = ({ signal }) => usersListMembers(tenantId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: tenantId !== null && tenantId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersListMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof usersListMembers>>>
export type UsersListMembersQueryError = ErrorModel


export function useUsersListMembers<TData = Awaited<ReturnType<typeof usersListMembers>>, TError = ErrorModel>(
 tenantId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersListMembers>>,
          TError,
          Awaited<ReturnType<typeof usersListMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersListMembers<TData = Awaited<ReturnType<typeof usersListMembers>>, TError = ErrorModel>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersListMembers>>,
          TError,
          Awaited<ReturnType<typeof usersListMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersListMembers<TData = Awaited<ReturnType<typeof usersListMembers>>, TError = ErrorModel>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListMembers>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Люди тенанта
 */

export function useUsersListMembers<TData = Awaited<ReturnType<typeof usersListMembers>>, TError = ErrorModel>(
 tenantId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersListMembers>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersListMembersQueryOptions(tenantId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






